import React, { useState } from "react";
import Section from "../../components/Section";
import { pageTitle } from "../../helpers/PageTitle";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import toast from "react-hot-toast";
import SecondaryButton from "../../components/SecondaryButton";

import PageHeader from "../../components/PageHeader";
import InputField from "../../components/InputField";

import { BsEye } from "react-icons/bs";
import PasswordInputField from "../../components/PasswordField";
import { Link, useNavigate, useParams } from "react-router-dom";
import { linearTopGradient } from "../../constants/colors";
import CommonMobileHeader from "../../components/Header/CommonMobileHeader";

export default function AppointmentBooked() {
  pageTitle("Appointment Booked");
  const { appointmentId } = useParams();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  return (
    <Wrapper>
      <Section topMd={60} topLg={20} topXl={110} bottomMd={200} bottomLg={150} bottomXl={110}>
        <div className="content-wrapper d-flex flex-column gap-1 justify-content-center">
          <CommonMobileHeader canBack={false} title="Appointment Booked" />
          <div className="mx-auto col-md-4 g-2 d-flex flex-column text-center justify-content-center align-items-center">
            <div className="bg-info-surface py-5 d-flex flex-column justify-content-center align-items-center">
              <h4>Appointment Booked</h4>
              <div className="col-4">
                <img src="/images/icons/ic_round_verified_big.png" />
              </div>
            </div>
            <div className="mt-4">
              <div>Appointment ID</div>
              <strong className="text-sprimary">{appointmentId}</strong>
            </div>
            <div className="mt-5 p-2">
              <h5 className="text-dark">Your appointment has been booked successfully.</h5>
              <p className="fs-normal text-grey2">Check Appointments tab for all your upcoming appointments.</p>
            </div>
            <GradientButton type="button" className="btn-gradient cs_shadow_1" onClick={() => navigate("/patient-appointments")}>
              My Appointments
            </GradientButton>
          </div>
        </div>
      </Section>
    </Wrapper>
  );
}
const Wrapper = styled.div``;
const GradientButton = styled.button`
  position: static;
  margin-top: 1rem;
  left: 0;
  right: 0;
  padding: 14px 16px 16px 14px;
  bottom: 0;
  color: #fff;
  outline: none;
  border: none;
  background: ${linearTopGradient};
  z-index: 5;
  border-radius: 8px;
  width: 100%;
  margin-left: 12px;
  margin-right: 12px;

  @media screen and (max-width: 768px) {
    position: fixed;
    margin: 0;
    border-radius: 0;
    bottom: 0;
  }
`;
